// extracted by mini-css-extract-plugin
export var appt = "styles-module--appt--9b73d";
export var check = "styles-module--check--15be3";